import { getCurrentUser } from "/@src/helpers/Utils";
import { isAuthGuardActive } from "/@src/constants/defaultValues";
import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_ERROR,
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_ERROR,
  LOGOUT_USER,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  SET_USER_DETAILS,
  SET_USER_DETAILS_LOADING,
} from "../contants";
import { buildCurrentFeatures } from "/@src/constants/plansAndFeatures";

const INIT_STATE = {
  currentUser: null,
  currentUserFeatures: {},
  currentUserLoading: true,
  forgotUserMail: "",
  newPassword: "",
  resetPasswordCode: "",
  loading: false,
  loginError: "",
  registrationError: "",
  resetPasswordError: "",
  forgotPasswordError: "",
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return { ...state, loading: true, error: "" };
    case LOGIN_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        currentUser: action.payload,
        loginError: "",
      };
    case LOGIN_USER_ERROR:
      return {
        ...state,
        loading: false,
        currentUser: null,
        loginError: action.payload.message,
      };
    case FORGOT_PASSWORD:
      return { ...state, loading: true, error: "" };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        forgotUserMail: action.payload,
        forgotPasswordError: "",
      };
    case FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        loading: false,
        forgotUserMail: "",
        forgotPasswordError: action.payload.message,
      };
    case RESET_PASSWORD:
      return { ...state, loading: true, resetPasswordError: "" };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        newPassword: action.payload,
        resetPasswordCode: "",
        resetPasswordError: "",
      };
    case RESET_PASSWORD_ERROR:
      return {
        ...state,
        loading: false,
        newPassword: "",
        resetPasswordCode: "",
        resetPasswordError: action.payload.message,
      };
    case REGISTER_USER:
      return { ...state, loading: true, registrationError: "" };
    case REGISTER_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        currentUser: action.payload,
        registrationError: "",
      };
    case REGISTER_USER_ERROR:
      return {
        ...state,
        loading: false,
        currentUser: null,
        registrationError: action.payload.message,
      };
    case LOGOUT_USER:
      return { ...state, currentUser: null, loginError: "" };
    case SET_USER_DETAILS:
      const {
        plan, 
        usages,
      } = action.payload;
      const currentUsages = {
        ...usages,
        totalStorageMb: getTotalStorage(usages.totalStorage),
      };
      const features = plan?.features || [];
      const featuresList = buildCurrentFeatures(features, currentUsages);
      return {
        ...state,
        currentUser: {
          ...action.payload,
          plan: {
            ...plan,
            subscription: action.payload.subscription,
          },
          usages: currentUsages,
        },
        currentUserFeatures: featuresList,
      };
    case SET_USER_DETAILS_LOADING:
      return {
        ...state,
        currentUserLoading: action.payload,
      };
    default:
      return { ...state };
  }
};

const getTotalStorage = (v) => {
  if (!v) {
    return "0";
  }
  return (v / 1024).toFixed(2);
};

export default reducer;